import { library } from "@fortawesome/fontawesome-svg-core";

import {
	faBullseye as farBullseye,
	faCalendar as farCalendar,
	faCamera as farCamera,
	faChartBar as farChartBar,
	faChevronDown as farChevronDown,
	faChevronLeft as farChevronLeft,
	faChevronRight as farChevronRight,
	faChevronUp as farChevronUp,
	faCircle as farCircle,
	faCog as farCog,
	faCogs as farCogs,
	faEllipsisH as farEllipsisH,
	faEllipsisV as farEllipsisV,
	faEnvelope as farEnvelope,
	faEye as farEye,
	faEyeSlash as farEyeSlash,
	faFileSpreadsheet as farFileSpreadsheet,
	faFileAlt as farFileAlt,
	faFileSearch as farFileSearch,
	faFileWord as farFileWord,
	faImage as farImage,
	faKey as farKey,
	faLightbulbOn as farLightbulbOn,
	faLightbulbSlash as farLightbulbSlash,
	faPaperclip as farPaperclip,
	faPaperPlane as farPaperPlane,
	faPencilAlt as farPencilAlt,
	faPlus as farPlus,
	faSackDollar as farSackDollar,
	faSearch as farSearch,
	faTachometerAltAverage as farTachometerAltAverage,
	faTrashAlt as farTrashAlt,
	faUsers as farUsers,
	faRulerHorizontal as farRulerHorizontal,
	faRulerVertical as farRulerVertical
} from "@fortawesome/pro-regular-svg-icons";

import {
	faAdjust as fasAdjust,
	faBan as fasBan,
	faCheck as fasCheck,
	faCopy as fasCopy,
	faExclamation as fasExclamation,
	faEye as fasEye,
	faFilePdf as fasFilePdf,
	faPencilAlt as fasPencilAlt,
	faPrint as fasPrint,
	faSave as fasSave,
	faTimesCircle as fasTimesCircle,
	faTriangle as fasTriangle
} from "@fortawesome/pro-solid-svg-icons";

import {
	faDollarSign as falDollarSign,
	faQuestionCircle as falQuestionCircle,
	faTimes as falTimes,
	faUsers as falUsers
} from "@fortawesome/pro-light-svg-icons";

// TODO: Change this to only browser icons for IE11 compatibility
import { fab } from "@fortawesome/free-brands-svg-icons";

library.add(
	fab,

	falDollarSign,
	falQuestionCircle,
	falTimes,
	falUsers,

	farBullseye,
	farCalendar,
	farCamera,
	farChartBar,
	farChevronDown,
	farChevronLeft,
	farChevronRight,
	farChevronUp,
	farCircle,
	farCog,
	farCogs,
	farEllipsisH,
	farEllipsisV,
	farEnvelope,
	farEye,
	farEyeSlash,
	farFileAlt,
	farFileSearch,
	farFileSpreadsheet,
	farFileWord,
	farImage,
	farKey,
	farLightbulbOn,
	farLightbulbSlash,
	farPaperclip,
	farPaperPlane,
	farPencilAlt,
	farPlus,
	farRulerHorizontal,
	farRulerVertical,
	farSackDollar,
	farSearch,
	farTachometerAltAverage,
	farTrashAlt,
	farUsers,

	fasAdjust,
	fasBan,
	fasCheck,
	fasCopy,
	fasExclamation,
	fasEye,
	fasFilePdf,
	fasPencilAlt,
	fasPrint,
	fasSave,
	fasTimesCircle,
	fasTriangle
);
